export default "__VITE_ASSET__B0ldIly7__"